import React from "react";
import { InfoIcon, ArrowRightIcon } from "./icons";

export default function TopTopicsCard({ topics = [], loading = false }) {
  return (
    <section className="dash-card">
      <div className="dash-card-header">
        <h2 className="dash-card-title">
          Top conversation topics
          <span className="an-info-icon" title="What visitors ask your assistant about most.">
            <InfoIcon />
          </span>
        </h2>
      </div>

      {loading ? (
        <ul className="an-topics">
          {[0, 1, 2, 3].map((row) => (
            <li key={row}>
              <span className="skel an-topics-skel-icon" />
              <span className="skel an-topics-skel-label" />
              <span className="skel an-topics-skel-track" />
            </li>
          ))}
        </ul>
      ) : topics.length === 0 ? (
        <p className="dash-empty">No topics for this period yet.</p>
      ) : (
        <ul className="an-topics">
          {topics.map((topic) => (
            <li
              key={topic.label}
              title={`${topic.label} - ${topic.percentLabel}% of turns${topic.count ? ` (${topic.count})` : ""}`}
            >
              <span className={`dash-stat-icon dash-stat-icon--${topic.variant} an-topics-icon`}>
                {topic.icon}
              </span>
              <span className="an-topics-label">{topic.label}</span>
              <span className="an-topics-track">
                <span style={{ width: `${Math.min(100, topic.percent)}%` }} />
              </span>
              <span className="an-topics-percent">{topic.percentLabel}%</span>
            </li>
          ))}
        </ul>
      )}

      <a href="#all-topics" className="dash-card-link an-view-link">
        View all topics
        <ArrowRightIcon />
      </a>
    </section>
  );
}
